import Shift from './Shift.vue'

export default Shift
